import { render, staticRenderFns } from "./pregive.vue?vue&type=template&id=428bd45a"
import script from "./pregive.vue?vue&type=script&lang=js"
export * from "./pregive.vue?vue&type=script&lang=js"
import style0 from "./pregive.vue?vue&type=style&index=0&id=428bd45a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428bd45a')) {
      api.createRecord('428bd45a', component.options)
    } else {
      api.reload('428bd45a', component.options)
    }
    module.hot.accept("./pregive.vue?vue&type=template&id=428bd45a", function () {
      api.rerender('428bd45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/pregive.vue"
export default component.exports